export const LIVE_STUDIO = [
  {
    title: "Live briefs, not hypothetical ones",
    body: "Studio briefs come from funded projects that are running now, so the constraints are real and the outcome matters to someone outside the classroom.",
  },
  {
    title: "Access to a development team",
    body: "The lab employs developers, so a strong student concept can be built and tested rather than left as a specification.",
  },
  {
    title: "Real users, through my own field relationships",
    body: "Students reach teachers, health workers and consumers through field relationships built over sixteen years of deployment work.",
  },
  {
    title: "Practitioners in the room",
    body: "People who build and ship products join critiques and reviews, so feedback reflects practice as well as theory.",
  },
];

export const COURSES = [
  { course: "DD 301 Introduction to Interaction Design", level: "BDes core", mobileDetail: "Designed by me, runs every year" },
  { course: "DD 304 Tangible User Interfaces", level: "BDes core", mobileDetail: "44 to 59 students" },
  { course: "DD 509 Interaction Design", level: "Master's and PhD elective", mobileDetail: null },
  { course: "DD 534 HCI in Virtual Reality", level: "Graduate and PhD elective", mobileDetail: null },
  { course: "DD 3304 Designing for Virtual Reality", level: "BDes core", mobileDetail: "New course, begins July 2027" },
  { course: "DD 302 Physical Computing", level: "BDes core", mobileDetail: null },
];

export const CURRICULUM_DESIGN = [
  { title: "MDes in Extended Reality", detail: "IIT Jodhpur" },
  { title: "MDes in Electronic Product Design", detail: "IIT Guwahati (Ministry of Electronics and Information Technology, ₹18 crore over five years)" },
  { title: "UX Design Programme", detail: "IIT Guwahati (fifteen-day residential certification)" },
];

export const COURSERA_COURSES = [
  { title: "UX Design: An Introduction", url: "https://coursera.org/learn/ux-design-an-introduction-iitg" },
  { title: "Designing User Interfaces and User Interactions", url: "https://coursera.org/learn/designing-user-interfaces-and-user-interactions-iitg" },
  { title: "User Research Methods and Practices", url: "https://coursera.org/learn/user-research-methods-and-practices-iitg" },
];

export const EVALUATION_TILES = [
  { value: "4.65", label: "highest" },
  { value: "3.92", label: "lowest" },
  { value: "4 or 5", label: "mode in every offering" },
  { value: "7", label: "offerings across three courses" },
];

export const EVALUATIONS = [
  { course: "DD 509 Interaction Design", semester: "January to May 2019", responses: 17, average: "4.65" },
  { course: "DD 509 Interaction Design", semester: "January to May 2025", responses: 49, average: "4.55" },
  { course: "DD 534 HCI in Virtual Reality", semester: "July to November 2022", responses: 16, average: "4.25" },
  { course: "DD 534 HCI in Virtual Reality", semester: "January to May 2024", responses: 44, average: "4.07" },
  { course: "DD 304 Tangible User Interfaces", semester: "July to November 2020", responses: 44, average: "4.14" },
  { course: "DD 304 Tangible User Interfaces", semester: "July to November 2023", responses: 59, average: "3.95" },
  { course: "DD 304 Tangible User Interfaces", semester: "July to November 2022", responses: 51, average: "3.92" },
];

export const OUTCOME_TILES = [
  { value: "9", label: "papers and posters from Tangible User Interfaces coursework" },
  { value: "7", label: "more from supervised thesis projects" },
  { value: "2", label: "peer-reviewed papers from a course run with Xerox Research Centre India, CATALYST and Audio Cues" },
  { value: "2,800+", label: "learners on the Coursera certification in UX design and HCI" },
];

export const OUTCOMES_MOBILE_CAPTION =
  "Three 2023 Master's theses on interface design for VR anatomy learning feed directly into the research thread on longitudinal adoption of immersive learning.";

export const STUDENT_VIDEOS = [
  { title: "Credlow - Micro-credit service for next billion users", id: "MMn8zgEsez4", url: "https://youtu.be/MMn8zgEsez4" },
  { title: "Sampoorn - an interactive, engaging and practice-based learning solution for class 1-2 students", id: "OKagFdcWVBc", url: "https://youtu.be/OKagFdcWVBc" },
  { title: "Software to create VR modules in Rural Healthcare", id: "FMWsSNXd9GI", url: "https://youtu.be/FMWsSNXd9GI" },
  { title: "Mubiks - Tangible music player for visually impaired", id: "ke920onJj6c", url: "https://youtu.be/ke920onJj6c" },
  { title: "Tangify - An interactive learning toolkit for differently abled children", id: "TIBcp5iKvtY", url: "https://youtu.be/TIBcp5iKvtY" },
  { title: "CoinBeam - Teaching Financial Transaction for Differently abled Children", id: "56GtZoHvgkY", url: "https://youtu.be/56GtZoHvgkY" },
  { title: "Novel input interactions for smartphones", id: "DdFfPH2Rhxo", url: "https://youtu.be/DdFfPH2Rhxo" },
  { title: "Krishti - A tangible interface to facilitate playful learning environment for conventional museums", id: "NoKv6jRGX9Y", url: "https://youtu.be/NoKv6jRGX9Y" },
];

export const HOME_TEACHING_TILES = [
  { value: "4.65", label: "highest course rating out of five" },
  { value: "16", label: "peer-reviewed papers and posters from coursework and supervised theses" },
  { value: "2,800+", label: "learners on the Coursera certification" },
  { value: "45", label: "Master's and undergraduate theses supervised" },
];
